import { enqueueSnackbar } from 'actions';

import {
	DashboardInspectRequest,
} from '../requests/DashboardInspectRequests.js';

export const DASHBOARD_INSPECT = 'DASHBOARD_INSPECT';

const onDashboardInspect = (value) => ({
	type: DASHBOARD_INSPECT,
	dashboard: value
});

export const DashboardInspect = (dashboardId, userId) => async dispatch => {
	await DashboardInspectRequest(dashboardId, userId).then(response => {
		dispatch(onDashboardInspect(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
